/*
 * Mobile swipe support for multi-variant product cards.
 *
 * Horizontal swipe on .pcard__media  → advances/retreats variant by
 * triggering the next/prev color swatch (which already runs the
 * ColorSwatch image-swap pipeline). Vertical movement is left alone
 * so the page still scrolls normally.
 */
(function () {
  var isArabic = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  var a11y = isArabic
    ? { image: 'الصورة', previous: 'الصورة السابقة', next: 'الصورة التالية' }
    : { image: 'Image', previous: 'Previous image', next: 'Next image' };
  // Bind unconditionally - non-touch devices simply never fire these events.
  var THRESHOLD = 40;       // px - minimum horizontal distance to count as swipe
  var V_RATIO = 1.4;        // horizontal must beat vertical by this factor

  function bind(card) {
    if (card.__pcardSwipeBound) return;
    var media = card.querySelector('.pcard__media');
    if (!media) return;

    // Two modes:
    // 1. Multi-color cards have <color-swatch> labels - swipe triggers
    //    the swatch click pipeline (also updates URL + selection state).
    // 2. Single-color cards have multiple .product__media-item siblings
    //    (the product's own gallery) - swipe prepends the next sibling
    //    directly, no swatch involved.
    var swatch = card.querySelector('color-swatch');
    var labels = swatch ? swatch.querySelectorAll('label.color-swatchimg') : null;
    var items = media.querySelectorAll('.product__media-item');

    var useSwatches = labels && labels.length > 1;
    var useItems = !useSwatches && items.length > 1;
    if (!useSwatches && !useItems) return;

    card.__pcardSwipeBound = true;

    // Let the browser keep vertical scrolling, but reserve horizontal
    // for our handler so the parent carousel/UL doesn't steal it.
    // touch-action is per-element, so we must set it on every descendant
    // - touches land on inner <img>/<a>, not on .pcard__media itself.
    media.style.touchAction = 'pan-y';
    media.querySelectorAll('*').forEach(function (el) {
      el.style.touchAction = 'pan-y';
    });

    var startX = 0, startY = 0, swiped = false, locked = '', ignoreGesture = false;

    media.addEventListener('touchstart', function (e) {
      // The quick-buy control now lives inside .pcard__media. Never treat a
      // touch that starts on it as a gallery swipe - otherwise the swipe
      // logic (and its post-swipe click suppression) can swallow the tap so
      // the + / stepper feels unresponsive on touch devices.
      ignoreGesture = !!(e.target.closest && e.target.closest('.pcard__buy'));
      if (ignoreGesture) return;
      var t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      swiped = false;
      locked = '';
    }, { passive: true });

    media.addEventListener('touchmove', function (e) {
      if (ignoreGesture) return;
      if (locked === 'v') return;
      var t = e.touches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (locked === 'h') {
        // Already committed to horizontal - keep blocking parent carousel.
        e.preventDefault();
        return;
      }
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      if (Math.abs(dx) > Math.abs(dy)) {
        locked = 'h';
        e.preventDefault();
      } else {
        locked = 'v';
      }
    }, { passive: false });

    media.addEventListener('touchend', function (e) {
      if (ignoreGesture) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (Math.abs(dx) < THRESHOLD) return;
      if (Math.abs(dx) < Math.abs(dy) * V_RATIO) return;

      swiped = true;
      // Step by STABLE image order (same path the arrows + dots use) so
      // 3+ image galleries advance correctly. The old logic brought the
      // 2nd DOM item to the front - but since the visible image is always
      // the first child, after moving image 2 up the 2nd item is the
      // previously-shown image 1, so "next" from image 2 toggled back to
      // image 1 instead of reaching image 3. dx<0 = next, dx>0 = prev.
      step(dx < 0 ? 1 : -1);
    }, { passive: true });

    /* ─── Pagination dots ────────────────────────────────────────────
       Tappable indicator synced with the swipe / swatch swap, shown on
       any card with 2+ images (all viewports). The visible image is
       always the first .product__media-item; swatch cards instead track
       the checked Color radio, with dots mapping 1:1 to the color labels. */
    var dotCount = useSwatches ? labels.length : items.length;
    /* Stable media-id order for single-color cards - captured once. The
       DOM reorders on each swipe/tap, but this lookup array does not, so
       a dot always points at the same image. */
    var itemOrder = [];
    if (useItems) {
      for (var oi = 0; oi < items.length; oi++) {
        itemOrder.push(items[oi].getAttribute('data-media-id'));
      }
    }
    /* Color radios scoped to the Color fieldset so the checked index maps
       1:1 to the color labels - the swatch markup also renders hidden
       Size/etc. radios that we must not count. */
    var colorRadios = [];
    if (useSwatches) {
      var colorFieldset = labels[0].closest('fieldset');
      if (colorFieldset) colorRadios = colorFieldset.querySelectorAll('input[type="radio"]');
    }

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'pcard__dots';
    dotsWrap.setAttribute('aria-hidden', 'true');
    var dots = [];
    var visibleDotCount = Math.min(dotCount, 3);
    for (var di = 0; di < visibleDotCount; di++) {
      var mediaIndex = visibleDotCount === dotCount
        ? di
        : Math.round(di * (dotCount - 1) / (visibleDotCount - 1));
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'pcard__dots-dot';
      dot.tabIndex = -1;
      dot.setAttribute('aria-label', a11y.image + ' ' + (mediaIndex + 1));
      dot.dataset.dotIndex = mediaIndex;
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }
    /* Appended BEFORE the animateObserver is wired so this insertion
       isn't seen as a media swap. querySelector('.product__media-item')
       still returns the first image, not this dots node. */
    media.appendChild(dotsWrap);

    function currentIndex() {
      if (useSwatches) {
        for (var ci = 0; ci < colorRadios.length; ci++) {
          if (colorRadios[ci].checked) return ci;
        }
        return 0;
      }
      var first = media.querySelector('.product__media-item');
      if (!first) return 0;
      var fi = itemOrder.indexOf(first.getAttribute('data-media-id'));
      return fi < 0 ? 0 : fi;
    }

    function syncDots() {
      var active = currentIndex();
      var activeDot = visibleDotCount === dotCount
        ? active
        : Math.round(active * (visibleDotCount - 1) / (dotCount - 1));
      for (var si = 0; si < dots.length; si++) {
        dots[si].classList.toggle('is-active', si === activeDot);
      }
    }

    // Bring the image at stable-order index `idx` to the front (it becomes
    // the visible :first-child). Used by both dot taps and swipe.
    function goToItem(idx) {
      var targetId = itemOrder[idx];
      if (targetId == null) return;
      var live = media.querySelectorAll('.product__media-item');
      for (var gi = 0; gi < live.length; gi++) {
        if (live[gi].getAttribute('data-media-id') === targetId) {
          live[gi].parentNode.insertBefore(live[gi], live[gi].parentNode.firstChild);
          break;
        }
      }
    }

    dotsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.pcard__dots-dot');
      // Always swallow taps inside the pill so they never reach the
      // card's full-cover PDP link underneath.
      e.stopPropagation();
      if (!btn) return;
      e.preventDefault();
      var target = parseInt(btn.dataset.dotIndex, 10);
      var cur = currentIndex();
      if (target === cur) return;
      // Same animation hint the swipe handler sets.
      media.setAttribute('data-swipe-dir', target > cur ? 'left' : 'right');
      if (useSwatches) {
        labels[target].click();
      } else {
        goToItem(target);
      }
      // The active dot updates via the animateObserver childList callback.
    });

    /* Step one image forward (delta +1) or back (-1) by stable order,
       wrapping at the ends. Shared by swipe and the desktop arrows. */
    function step(delta) {
      var total = useSwatches ? labels.length : itemOrder.length;
      if (total < 2) return;
      var cur = currentIndex();
      var nxt = cur + delta;
      if (nxt < 0) nxt = total - 1;
      if (nxt >= total) nxt = 0;
      // Forward (next) slides in from the right; back slides from the left.
      media.setAttribute('data-swipe-dir', delta > 0 ? 'left' : 'right');
      if (useSwatches) {
        labels[nxt].click();
      } else {
        goToItem(nxt);
      }
    }

    /* ─── Desktop hover arrows ────────────────────────────────────────
       Prev/next buttons over the image, revealed on card hover (CSS gates
       them to mouse/desktop). Same stepping as swipe; mobile relies on
       swipe + dots so these stay hidden there. */
    var navPrev = document.createElement('button');
    navPrev.type = 'button';
    navPrev.className = 'pcard__nav pcard__nav--prev';
    navPrev.tabIndex = -1;
    navPrev.setAttribute('aria-label', a11y.previous);
    navPrev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
    var navNext = document.createElement('button');
    navNext.type = 'button';
    navNext.className = 'pcard__nav pcard__nav--next';
    navNext.tabIndex = -1;
    navNext.setAttribute('aria-label', a11y.next);
    navNext.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';
    media.appendChild(navPrev);
    media.appendChild(navNext);

    function onArrow(delta) {
      return function (e) {
        // Don't let the tap fall through to the card's PDP link.
        e.preventDefault();
        e.stopPropagation();
        step(delta);
      };
    }
    navPrev.addEventListener('click', onArrow(-1));
    navNext.addEventListener('click', onArrow(1));

    /* ─── Hover autoplay (desktop) ────────────────────────────────────
       Hovering the card cycles through its images; hovering an arrow or
       the dots pill pauses so the shopper can step manually (resumes
       when they move back onto the card). Mouse/desktop only and
       disabled under prefers-reduced-motion. mouseenter/leave (not
       over/out) ignore child transitions, so moving card → arrow
       doesn't fire card-leave. */
    if (
      window.matchMedia &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      /* 3000ms cadence (was 1400ms) - slower hover cycle gives
         each image room to register before the next slides in,
         feels deliberate/premium instead of rapid-cycling. */
      var AUTOPLAY_MS = 3000;
      var autoplayTimer = null;
      var cardHover = false;
      var pauseHover = false;

      function updateAutoplay() {
        var shouldRun = cardHover && !pauseHover;
        if (shouldRun && !autoplayTimer) {
          autoplayTimer = setInterval(function () { step(1); }, AUTOPLAY_MS);
        } else if (!shouldRun && autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      card.addEventListener('mouseenter', function () { cardHover = true; updateAutoplay(); });
      card.addEventListener('mouseleave', function () { cardHover = false; updateAutoplay(); });
      [navPrev, navNext, dotsWrap].forEach(function (zone) {
        zone.addEventListener('mouseenter', function () { pauseHover = true; updateAutoplay(); });
        zone.addEventListener('mouseleave', function () { pauseHover = false; updateAutoplay(); });
      });
    }

    // Animate the new :first-child .product__media-item sliding in
    // whenever ColorSwatch.updateMedia prepends a different media.
    var animateObserver = new MutationObserver(function () {
      var first = media.querySelector('.product__media-item');
      if (!first) return;
      // Default to 'left' (next) if the change came from a tap, not a swipe.
      var dir = media.getAttribute('data-swipe-dir') || 'left';
      // Restart animation by removing the class first.
      first.classList.remove('pcard-swipe-in--left', 'pcard-swipe-in--right');
      // Force reflow so the next addition restarts the animation.
      // eslint-disable-next-line no-unused-expressions
      first.offsetWidth;
      first.classList.add(dir === 'right' ? 'pcard-swipe-in--right' : 'pcard-swipe-in--left');
      media.removeAttribute('data-swipe-dir');
      syncDots();
    });
    animateObserver.observe(media, { childList: true });
    syncDots();

    // Suppress the synthesized click after a horizontal swipe so the
    // card's full-cover PDP link doesn't fire.
    media.addEventListener('click', function (e) {
      // Never suppress clicks on the quick-buy control (it lives inside the media).
      if (e.target.closest && e.target.closest('.pcard__buy')) return;
      if (swiped) {
        e.preventDefault();
        e.stopPropagation();
        swiped = false;
      }
    }, true);
  }

  function init() {
    document.querySelectorAll('.pcard').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan after AJAX loads (collection infinite scroll, predictive search, etc.)
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains('pcard')) bind(node);
        if (node.querySelectorAll) node.querySelectorAll('.pcard').forEach(bind);
      }
    }
  });
  function observeProductCardChanges() {
    // This asset can execute from <head> before <body> exists. Passing null to
    // MutationObserver.observe throws and disables swipe/dots for every card,
    // including cart-drawer recommendations.
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeProductCardChanges, { once: true });
  } else {
    observeProductCardChanges();
  }
})();
